import { createSelector } from 'reselect';
import shuffle from 'lodash/shuffle';
import config from '../configs';

const { maxMerchants } = config;

export const selectTrendingStores = state => state.trendingStores;
export const selectTrendingStoresConfig =
  createSelector(selectTrendingStores, trendingStores => trendingStores.config);
export const selectTrendingStoresIsLoading =
  createSelector(selectTrendingStores, trendingStores => trendingStores.isLoading);
export const selectTrendingStoresIsLoaded =
  createSelector(selectTrendingStores, trendingStores => trendingStores.isLoaded);
export const selectTrendingStoresRecords =
  createSelector(selectTrendingStores, trendingStores => (
    shuffle(trendingStores.merchants).splice(0, maxMerchants)
  ));
export const selectTrendingStoresDyData =
  createSelector(selectTrendingStores, trendingStores => trendingStores.dyData);
